import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { CustomLink } from '../CustomLink';
import {
  setAdriverSelectedCity,
  setChosenLocationNames,
  setCurrentState,
  setLocationIds,
  switchTab,
  togglePromotionModalView
} from '../../actions';
import CONFIG from '../../config';
import useScreenSize from '../../hooks/useScreenSize';
import {
  LogoFlexibleBlock,
  StyledLogoIcon,
  Switcher,
  SwitcherBlock,
  SwitcherIcon
} from './styled';
import HeaderModalMenu from '../HeaderModalMenu';
import { Cities } from '../../utils/helpers/constants';

const HamburgerMenu = () => {
  const dispatch = useDispatch();
  const [isOpenHeaderMenu, setIsOpenHeaderMenu] = useState(false);
  const [isHoveringModal, setIsHoveringModal] = useState(false);
  const [isHoveringSwitcher, setIsHoveringSwitcher] = useState(false);
  const { isSmall } = useScreenSize();
  const { contacts } = CONFIG;

  const handleLogoClick = () => {
    dispatch(switchTab(0));
    dispatch(setChosenLocationNames([]));
    dispatch(setLocationIds([]));
    dispatch(setCurrentState(null));
    dispatch(setAdriverSelectedCity(Cities.Baku.az));
    dispatch(togglePromotionModalView(false));
  };

  const onSwitcherClick = () => {
    setIsOpenHeaderMenu(isOpen => !isOpen);
  };

  const handleSwitcherMouseEnter = () => {
    setIsHoveringSwitcher(true);
  };

  const handleSwitcherMouseLeave = () => {
    setIsHoveringSwitcher(false);
  };

  const handleModalMenuMouseEnter = () => {
    setIsHoveringModal(true);
  };

  const handleModalMenuMouseLeave = () => {
    setIsHoveringModal(false);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      if (!isHoveringModal && !isHoveringSwitcher) {
        setIsOpenHeaderMenu(false);
      } else {
        setIsOpenHeaderMenu(true);
      }
    }, 300);

    return () => clearTimeout(timer);
  }, [isHoveringModal, isHoveringSwitcher]);

  return (
    <LogoFlexibleBlock data-cy="header-menu">
      {!isSmall && (
        <SwitcherBlock
          onClick={onSwitcherClick}
          onKeyPress={onSwitcherClick}
          onMouseEnter={handleSwitcherMouseEnter}
          onMouseLeave={handleSwitcherMouseLeave}
          role="button"
          tabIndex="0"
          aria-label="Open menu"
        >
          <Switcher
            active={isOpenHeaderMenu}
            data-cy="header-menu-toggle-icons"
          >
            <SwitcherIcon active={isOpenHeaderMenu} />
          </Switcher>
        </SwitcherBlock>
      )}
      <CustomLink href="/" onClick={handleLogoClick}>
        <StyledLogoIcon
          data-cy="header-menu-logo"
          data-stat="header-menu-logo"
          src="/static/images/brown-logo.svg"
          alt="logo"
          width={isSmall ? 85 : 80}
          height={20}
          isShowBurgerIcon={!isSmall}
        />
      </CustomLink>
      <HeaderModalMenu
        {...{
          contacts,
          isOpenHeaderMenu,
          setIsOpenHeaderMenu,
          handleModalMenuMouseLeave,
          handleModalMenuMouseEnter
        }}
      />
    </LogoFlexibleBlock>
  );
};

export default HamburgerMenu;
